import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = [ "notification", "scrollContainer", "btnMarkAsRead", "btnArchive", "labelSelected" ]
  static values = { autoShow: Boolean }

  connect() {
    this.scrollHandler = this.checkVisibleAndMarkRead.bind(this);
    // this.scrollContainerTarget.addEventListener('scroll', this.scrollHandler);

    // Reset selection state after turbo stream renders
    this.resetHandler = this.resetSelectionState.bind(this);
    document.addEventListener('turbo:before-stream-render', this.resetHandler);

    // Tear the modal down before Turbo snapshots the page, so restoring the
    // page from cache (e.g. hitting back after a modal CTA) doesn't revive an
    // open modal and its backdrop.
    this.beforeCacheHandler = this.teardownModalForCache.bind(this);
    document.addEventListener('turbo:before-cache', this.beforeCacheHandler);

    // Auto-show modal if autoShow value is true
    if (this.autoShowValue) {
      this.showInformationalModal()
    }
  }

  teardownModalForCache() {
    if (this.bsModal) {
      this.bsModal.dispose()
      this.bsModal = null
    }
    const container = document.getElementById('informational_notification_modal_container')
    if (container) {
      container.innerHTML = ''
    }
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
    document.body.classList.remove('modal-open')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
  }

  disconnect() {
    // this.scrollContainerTarget.removeEventListener('scroll', this.scrollHandler);
    document.removeEventListener('turbo:before-stream-render', this.resetHandler);
    document.removeEventListener('turbo:before-cache', this.beforeCacheHandler);

    // Clean up modal if this controller was attached to one
    if (this.bsModal) {
      this.bsModal.hide()
      this.bsModal.dispose()
      this.bsModal = null
    }
  }

  resetSelectionState() {
    // Reset the "select all" checkbox
    const checkAllBox = this.element.querySelector('input[type=checkbox][name=inbox-check-all]')
    if (checkAllBox) {
      checkAllBox.checked = false
    }

    // Reset the selection count and button styles
    this.updateNotificationActions(0)
  }

  checkVisibleAndMarkRead() {
    this.notificationTargets.forEach((notification) => {
      if (this.isInViewport(notification)) {
        const id = notification.dataset.notificationIdParam;
        $.ajax({
          method: "PATCH",
          url: `/notifications/${id}`,
          success: function(data) {
            if ($(notification).closest('li').hasClass('active')) {
              $('.number_notification').html(parseInt($('.number_notification').html()) - 1)
              $(notification).closest('li').removeClass('active')
              if ($('.number_notification').html() == '0') {
                $('.number_notification').hide();
              }
            }
          }
        });
      }
    });
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const parentRect = this.scrollContainerTarget.getBoundingClientRect();
    return (
      rect.top >= parentRect.top &&
      rect.left >= parentRect.left &&
      rect.bottom <= parentRect.bottom &&
      rect.right <= parentRect.right
    );
  }

  markRead(e){
    const { params: { id } } = e;
    $.ajax({
      method: "PATCH",
      url: `/notifications/${id}`,
      success: function(data) {
        if ($(e.target).closest('li').hasClass('active')) {
          $('.number_notification').html(parseInt($('.number_notification').html()) - 1)
          $(e.target).closest('li').removeClass('active')
        }
      }
    });
  }

  // Opening a referral or conversation from the feed marks the notification
  // read on the server (ReferralsController / ConversationsController with
  // notification_id). In the native app the feed is restored from Turbo's
  // snapshot cache on the way back, so reflect it in the page now — the
  // snapshot is taken after this runs and the restored page already shows
  // it read.
  markOpenedAsRead(e) {
    const item = e.currentTarget.closest(".activity-feed-notification")
    if (!item || !item.classList.contains("unread-notification")) return
    item.classList.remove("unread-notification")

    document.querySelectorAll("#mobile-activity-unread-badge, [id^='count_notifications_user_']").forEach((badge) => {
      const count = parseInt(badge.textContent, 10)
      if (Number.isNaN(count)) return
      const next = Math.max(0, count - 1)
      badge.textContent = next
      if (next === 0) badge.classList.add("d-none")
    })
  }

  selectNotificationItem(e) {
    const notifications = document.querySelectorAll('input[type=checkbox][name="notification_ids[]"]:checked')
    const parent = e.target.closest('.notification-item')
    parent.classList.toggle('selected-notification', parent.querySelector('input[type=checkbox][name="notification_ids[]"]').checked)
    this.updateNotificationActions(notifications.length)
  }

  selectNotificationItems(e) {
    const check_all_box = e.currentTarget.querySelector('input[type=checkbox][name=inbox-check-all]')
    const notifications = document.querySelectorAll('input[type=checkbox][name="notification_ids[]"]')
    notifications.forEach(notification => {
      notification.checked = check_all_box.checked
      notification.closest('.notification-item').classList.toggle('selected-notification', check_all_box.checked)
    })
    this.updateNotificationActions(check_all_box.checked ? notifications.length : 0)
  }

  updateNotificationActions(count) {
    const hasSelectedItems = count > 0
    this.hasBtnMarkAsReadTarget && this.btnMarkAsReadTarget.classList.toggle('opacity-25', !hasSelectedItems)
    this.hasBtnArchiveTarget && this.btnArchiveTarget.classList.toggle('opacity-25', !hasSelectedItems)
    this.labelSelectedTarget.classList.toggle('d-none', !hasSelectedItems)
    this.labelSelectedTarget.innerText = `${count} selected`
  }

  updateMany(e) {
    e.preventDefault()
    const button = e.currentTarget
    const actionType = button.dataset.actionType
    const category = button.dataset.category
    const source = button.dataset.source
    const form = this.createUpdateForm()

    let actionUrl = `/notifications/update_many?action_type=${actionType}&category=${category}`
    if (source) {
      actionUrl += `&source=${source}`
    }
    form.action = actionUrl;

    const notifications = document.querySelectorAll('input[type=checkbox][name="notification_ids[]"]:checked')
    notifications.forEach(el => {
      const clone = el.cloneNode(true);
      clone.classList.add('d-none')
      form.appendChild(clone);
    });

    form.requestSubmit()
    setTimeout(() => form.remove(), 0)
  }

  createUpdateForm() {
    const form = document.createElement('form');
    form.method = 'post';
    form.style.display = 'none';
    form.setAttribute('data-turbo', 'true');

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'authenticity_token';
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    document.body.appendChild(form);
    return form
  }

  showInformationalModal() {
    const modal = document.getElementById('informational_notification_modal')
    if (modal) {
      this.bsModal = new Modal(modal)

      // Clear the container when modal is hidden to prevent stale state
      modal.addEventListener('hidden.bs.modal', () => {
        const container = document.getElementById('informational_notification_modal_container')
        if (container) {
          container.innerHTML = ''
        }
        if (this.bsModal) {
          this.bsModal.dispose()
          this.bsModal = null
        }
      }, { once: true })

      this.bsModal.show()
    }
  }
}